import { render, staticRenderFns } from "./destinaForm.vue?vue&type=template&id=b84e31a0&scoped=true&"
import script from "./destinaForm.vue?vue&type=script&lang=js&"
export * from "./destinaForm.vue?vue&type=script&lang=js&"
import style0 from "./destinaForm.vue?vue&type=style&index=0&id=b84e31a0&lang=less&scoped=true&"
import style1 from "./destinaForm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84e31a0",
  null
  
)

component.options.__file = "destinaForm.vue"
export default component.exports